var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-badge',
    ("dp-badge--size-" + _vm.size),
    ("dp-badge--state-" + _vm.stateClass),
    {
      'dp-badge--full-width': _vm.fullWidth,
    } ]},[(_vm.icon)?_c('dp-icon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.displayText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }